import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

import BannersnackEditorModal from '../BannersnackEditorModal';
import CreativeModal from '../CreativeModal';
import type { IUseAddBannersnackBuildFlowParams } from './AddBannersnackBuildFlow.hooks';
import { useAddBannersnackBuildFlow } from './AddBannersnackBuildFlow.hooks';

export interface IAddBannersnackBuildFlowProps extends IUseAddBannersnackBuildFlowParams {
  isOpen: boolean;
}

function AddBannersnackBuildFlow({
  isOpen,
  campaignId,
  eventId,
  creatives,
  onAppear,
  onComplete,
  onBack,
  onCancel,
}: Readonly<IAddBannersnackBuildFlowProps>): JSX.Element {
  const { t } = useTranslation();

  const {
    step,
    creative,
    isLoading,
    handleEditorNext,
    handleCloseModal,
    handleBackToEditor,
    handleBack,
    handleCancel,
  } = useAddBannersnackBuildFlow({
    campaignId,
    eventId,
    creatives,
    onAppear,
    onComplete,
    onBack,
    onCancel,
  });

  if (step === 'editor') {
    return (
      <BannersnackEditorModal
        creative={creative}
        doneDisabled={isLoading}
        leftActions={
          <Button disabled={isLoading} name={'back'} onClick={handleBack}>
            {t('Back')}
          </Button>
        }
        onCancel={handleCancel}
        onDone={handleEditorNext}
        opened={isOpen}
      />
    );
  }

  return (
    <CreativeModal
      campaignId={campaignId}
      creative={creative}
      onClose={handleCloseModal}
      onEditInBannersnack={handleBackToEditor}
      opened={isOpen}
    />
  );
}

export default AddBannersnackBuildFlow;
